// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__4mMSq","requiredAsterisk":"Info_requiredAsterisk__1n3RN"};